import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as notificationsActions from './notifications.actions';
import * as sessionActions from '../../store/session.actions';
import { NotificationsService } from './services/notifications.service';
import { interval, EMPTY } from 'rxjs';
import { switchMap, map, concatMap, withLatestFrom } from 'rxjs/operators';
import { AuthSelectors } from '../../store';

@Injectable()
export class NotificationsEffects {
     reloadNotifications$ = createEffect(() => interval(300000).pipe(map(() => new notificationsActions.LoadNotifications())));

     loadNotifications$ = createEffect(() => this.actions$.pipe(
        ofType(notificationsActions.LOAD_NOTIFICATIONS),
        withLatestFrom(this.authSelector.loggedIn$),
        concatMap(([, loggedIn]) => {
            if (loggedIn) {
                return this.notificationService
                    .getNotifications()
                    .pipe(
                        switchMap(notifications => [
                            new notificationsActions.LoadNotificationsSuccess(notifications),
                            new sessionActions.SetMenuNotifications(notifications)
                        ])
                    );
            } else {
                return EMPTY;
            }
        })
    ));

     loadPlanerGodkendt$ = createEffect(() => this.actions$.pipe(
        ofType(notificationsActions.LOAD_PLANERGODKENDT),
        switchMap(() => this.notificationService.loadPlanerGodkendt().pipe(
            map(planerGodkendt => new notificationsActions.LoadPlanerGodkendtSucces(planerGodkendt))
        ))
    ));

     updatePlanerGodkendt$ = createEffect(() => this.actions$.pipe(
        ofType<notificationsActions.UpdatePlanerGodkendt>(notificationsActions.UPDATE_PLANERGODKENDT),
        map(action => action.payload),
        concatMap((id) => {
            return this.notificationService.updateSetPlanerGodkendt(id).pipe(
                switchMap((planerGodkendt) => [
                    new notificationsActions.UpdatePlanerGodkendtSuccess(planerGodkendt),
                    new notificationsActions.LoadNotifications()
                ])
            );
        })
    ));

     loadPopups$ = createEffect(() => this.actions$.pipe(
        ofType(notificationsActions.LOAD_POPUPS),
        switchMap(() => this.notificationService.loadPopups().pipe(
            map(popups => new notificationsActions.LoadPopupsSucces(popups))
        ))
    ));

     updatePopups$ = createEffect(() => this.actions$.pipe(
        ofType(notificationsActions.UPDATE_POPUPS),
        concatMap((action: notificationsActions.UpdatePopups) => this.notificationService
            .updatePopupNotification(action.payload)
            .pipe(map((popup) => new notificationsActions.UpdatePopupsSuccess(popup)))
        )
    ));

    constructor(
        private actions$: Actions,
        private notificationService: NotificationsService,
        private authSelector: AuthSelectors,
    ) {}
}
